module.exports = __webpack_public_path__ + "img/loginLogo.86fde755.png";